<tokens-browser-start [allowDigipas]="true" [browserName]="browserName" (next)="onNext()" (back)="onBack()"> </tokens-browser-start>
